module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Regular-fc5973283fa334f121eab2cc2ba8ecc2.woff2";